import React from "react";
import { RegistrationDataLoadingDialog } from "./registrationData-loading-dialog/RegistrationDataLoadingDialog";
import { RegistrationDataUIProvider } from "./RegistrationDataUIContext";
import { RegistrationDataCard } from "./RegistrationDataCard";

export function RegistrationDataPage() {

  return (
    <RegistrationDataUIProvider>
      <RegistrationDataLoadingDialog />
      <RegistrationDataCard />
    </RegistrationDataUIProvider>
  );
}
